import { Result } from 'antd'
import { FC } from 'react'

export const Error500Template: FC = () => (
  <Result
    status="500"
    title="ページが表示できません"
    subTitle="ご不便をおかけし申し訳ございません。不明なエラーが発生いたしました。"
  />
)
